<template>
    <div class="login-vue" :style="bg">
        <div class="container">
            <p class="title">欢迎登录</p>
            <div class="input-c">
                <Input prefix="ios-contact" v-model="account" placeholder="用户名" clearable @on-blur="verifyAccount"/>
                <p class="error">{{ accountError }}</p>
            </div>
            <div class="input-c">
                <Input type="password" v-model="pwd" prefix="md-lock" placeholder="密码" clearable @on-blur="verifyPwd"
                       @keyup.enter.native="submit"/>
                <p class="error">{{ pwdError }}</p>
            </div>
<!--            <div class="input-c" style="margin-top: -5px">-->
<!--                <vue-drag-verify-->
<!--                    :width="300"-->
<!--                    :height="36"-->
<!--                    ref="verifyRef"-->
<!--                    text="请按住滑块拖动"-->
<!--                    successText="验证通过"-->
<!--                    :background="'#5fc3ee'"-->
<!--                    :progressBarBg="'#42b983'"-->
<!--                    :handlerBg="'#35b5ec'"-->
<!--                    :completedBg="'#42b983'"-->
<!--                    :circle="false"-->
<!--                    @passcallback="onVerifySuccess"/>-->
<!--                <p v-if="verifyError !== ''" class="error" style="position: absolute">{{ verifyError }}</p>-->
<!--            </div>-->
            <Button :loading="isShowLoading" class="submit" type="primary"
                    @click="submit" style="font-size: 16px;height: 38px">登陆
            </Button>
        </div>
        <a style="position: fixed; bottom: 10px" href="http://beian.miit.gov.cn" target="_blank">
            滇ICP备2022005684号-1
        </a>
    </div>
</template>

<script>
import {login} from '@/api'

export default {
    name: 'login',
    data() {
        return {
            account: '',
            pwd: '',
            accountError: '',
            pwdError: '',
            verifyError: '',
            isShowLoading: false,
            bg: {},
        }
    },
    created() {
        this.bg.backgroundImage = 'url(' + require('../assets/imgs/bg07.jpg') + ')'
    },
    watch: {
        $route: {
            handler(route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true,
        },
    },
    methods: {
        // onVerifySuccess() {
        //     const progressBar = this.$refs.verifyRef.$el.querySelector('.dv_progress_bar')
        //     if (progressBar) {
        //         progressBar.style.width = '100%'
        //     }
        //     this.isVerified = true
        //     this.verifyError = ''
        // },
        verifyAccount() {
            if (this.account.trim() === '') {
                this.accountError = '账号不能为空'
            } else {
                this.accountError = ''
            }
        },
        verifyPwd() {
            if (this.pwd.trim() === '') {
                this.pwdError = '密码不能为空'
            } else {
                this.pwdError = ''
            }
        },
        register() {

        },
        forgetPwd() {

        },
        submit() {
            if (this.account.trim() === '') {
                this.accountError = '账号不能为空'
                return
            }
            if (this.pwd.trim() === '') {
                this.pwdError = '密码不能为空'
                return
            }
            login({account: this.account, password: this.pwd}).then((res) => {
                sessionStorage.setItem('token', res.data.token)
                res.data.token = ''
                sessionStorage.setItem('current-user', JSON.stringify(res.data))
                this.$router.push({path: this.redirect || '/home'}).catch(() => {
                })
            })
        },
    },
}
</script>

<style>
.login-vue {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0565a4;
    background-size: 100% 100%; /* 强制拉伸填满 */
    background-position: center;
    background-repeat: no-repeat;
}

.login-vue .container {
    background: rgba(255, 255, 255);
    width: 400px;
    text-align: center;
    border-radius: 10px;
    padding: 30px 30px 50px 30px;
    position: relative;
    left: 360px;
    top: -30px;
}

.login-vue .ivu-input {
    background-color: transparent;
    color: #0565a4;
    outline: #0565a4;
    border-color: #0565a4;
}

.login-vue ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: rgba(255, 255, 255, .8);
}

.login-vue :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(255, 255, 255, .8);
}

.login-vue ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(255, 255, 255, .8);
}

.login-vue :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(255, 255, 255, .8);
}

.login-vue .title {
    font-size: 18px;
    margin-bottom: 20px;
}

.login-vue .input-c {
    margin: auto;
    width: 300px;
}

.login-vue .error {
    color: red;
    text-align: left;
    margin: 5px auto;
    font-size: 12px;
    padding-left: 30px;
    height: 20px;
}

.login-vue .submit {
    width: 300px;
    margin-top: 10px;
}

.login-vue .account {
    margin-top: 30px;
}

.login-vue .account span {
    cursor: pointer;
}

.login-vue .ivu-icon {
    color: #0565a4;
}

.login-vue .ivu-icon-ios-close-circle {
    color: #777;
}

.drag_verify .dv_text {
    color: #f1f1f1 !important; /* 强制覆盖默认颜色 */
    font-size: 14px !important;
}
</style>
